const configurations = {
    optionsLoader: {
        color: '#212223',
        loader: 'dots',
        zIndex: 9999
    }
}

export default configurations
